module.exports = __webpack_public_path__ + "img/bd.61f407f0.png";